import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent }    from './home.component';
import { ReleaseDetailsComponent }  from '../release-details/release-details.component';

import { AuthGuard } from '../auth-guard.service';

const homeRoutes: Routes = [
  { path: 'home', redirectTo: '/Home' ,  canActivate: [AuthGuard]},
  { path: 'release/:id', redirectTo: '/Release/:id',  canActivate: [AuthGuard] },
  { path: 'Home',  component: HomeComponent , canActivate: [AuthGuard]},
  { path: 'Release/:id', component: ReleaseDetailsComponent ,  canActivate: [AuthGuard]}
];

@NgModule({
  imports: [
    RouterModule.forChild(homeRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class HomeRoutingModule { }